// extracted by mini-css-extract-plugin
module.exports = {"MainBg":"Header_MainBg__WWh5P","covering":"Header_covering__1JNgt"};